module.exports = __webpack_public_path__ + "static/media/AirbnbCerealApp-Medium.01fb7ca5.woff";